import $ from 'jquery';
import run from '../../../utilities/run';
require("./brandingLogin.less");


run(".branding-login", ()=>{
  setupLoginForm();
});

function setupLoginForm(){
  $(".footer").addClass("q-pad-vert-lg q-pad-horz-xl");
}



// WEBPACK FOOTER //
// ./src/pages/hcu/login/login.js